import { render, staticRenderFns } from "./AppRouterLink.vue?vue&type=template&id=138360fd&scoped=true&"
import script from "./AppRouterLink.vue?vue&type=script&lang=js&"
export * from "./AppRouterLink.vue?vue&type=script&lang=js&"
import style0 from "./AppRouterLink.vue?vue&type=style&index=0&id=138360fd&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138360fd",
  null
  
)

export default component.exports